import { render } from "./feed.vue?vue&type=template&id=accbceca&scoped=true"
import script from "./feed.vue?vue&type=script&lang=js"
export * from "./feed.vue?vue&type=script&lang=js"

import "./feed.vue?vue&type=style&index=0&id=accbceca&scoped=true&lang=css"

import exportComponent from "/media/whoami/010101010/Prosofty/PublicOpinion/frontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-accbceca"]])

export default __exports__